import { IBreadcrumbSchema } from '../../../node/repositories/countryside-search/entities/breadcrumbs/BreadcrumbSchema';
import { IApplicationState } from '../../types/store';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumbSchema[] => {
  return state.villageList.breadcrumbs || [];
};
